import { Link } from 'react-router-dom';
import { Stack, Typography, Button, Box } from '@mui/material';
import { IllustrationFailedInitialization } from './illustrations/IllustrationFailedInitialization';

export const InitializationFailedPlaceholder = () => {
  return (
    <Box
      sx={{
        display: 'flex',
        justifyContent: 'center',
        width: '100%',
        minHeight: '90vh',
        backgroundColor: '#ffffff',
      }}
    >
      <Stack
        justifyContent="center"
        alignItems="center"
        spacing={3}
      >
        <IllustrationFailedInitialization />
        <Stack
          justifyContent="center"
          alignItems="center"
          spacing={1}
        >
          <Typography
            variant="subtitle1"
            sx={{ fontWeight: 600, fontSize: '27px' }}
          >
            Oops! Failed to initialize.
          </Typography>
          <Typography
            variant="subtitle1"
            sx={{ fontWeight: 300, fontSize: '16px' }}
          >
            {`We are preparing to serve you better.`}
          </Typography>
        </Stack>
        <Button
          component={Link}
          to="/"
          variant="contained"
          sx={{
            backgroundColor: '#a7c4e5',
            color: '#3b6fac',
            boxShadow: 'none',
            borderRadius: 1.3,
            '&:hover': { backgroundColor: '#a7c4e5', color: '#3b6fac' },
          }}
        >
          Go to Homepage
        </Button>
      </Stack>
    </Box>
  );
};
